import {useTranslation} from "react-i18next";
import {useTheme} from "@mui/material";
import {
    AUTOMATIC,FCA_BANK, MANUAL
} from "../../finessecurity/component/Constants";


export const useEntrySourceValues = () => {
    const {t} = useTranslation(['finessecurity'], {keyPrefix: 'blackList'});
    const theme = useTheme();

    const getEntrySourcelLabel = (status: number) => {
        switch (status) {
            case MANUAL: return t('entrySourceValues.manual');
            case FCA_BANK: return t('entrySourceValues.fcaBank');
            case AUTOMATIC: return t('entrySourceValues.automatic');

            default : return '-'
        }
    };

    return {
        getEntrySourcelLabel
    }
}